import { useTranslation } from "@/hooks";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	Icon,
} from "@st-marketplace/ui";
import type { FC } from "react";
import UsdtTransferStep, { type AnyAutoPayment } from "./UsdtTransferStep";

interface PaymentAddDialogUsdtInfoProps {
	data: AnyAutoPayment;
	open: boolean;
	onOpenChange: (value: boolean) => void;
	onSuccess: () => void;
}

/**
 * The transfer step on its own, for resuming a payment from the payments list.
 * In the add-payment flow it is a step of that dialog rather than a new window.
 */
const PaymentAddDialogUsdtInfo: FC<PaymentAddDialogUsdtInfoProps> = ({
	data,
	open,
	onOpenChange,
	onSuccess,
}) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="w-full max-w-lg">
				<DialogHeader>
					<DialogTitle className="flex items-center gap-3">
						<Icon name="exchange-line" className="text-primary-100" />
						{t("payment.add.autoDialog.title")}
					</DialogTitle>
				</DialogHeader>
				<div className="flex min-h-[32rem] flex-col">
					<UsdtTransferStep
						data={data}
						secondaryLabel={t("common.button.close")}
						onSecondary={() => onOpenChange(false)}
						onConfirmed={onSuccess}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default PaymentAddDialogUsdtInfo;
